"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _communicationIllus = _interopRequireDefault(require("../../assets/images/communication-illus.svg"));
var _cyclistIllus = _interopRequireDefault(require("../../assets/images/cyclist-illus.svg"));
var _hourraIllus = _interopRequireDefault(require("../../assets/images/hourra-illus.svg"));
var _ideaIllus = _interopRequireDefault(require("../../assets/images/idea-illus.svg"));
var _journeysIllus = _interopRequireDefault(require("../../assets/images/journeys-illus.svg"));
var _lifeIllus = _interopRequireDefault(require("../../assets/images/life-illus.svg"));
var _environment = require("../../environment");
var _button = require("../button");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const wayToEarnPoints = ['sponsorship', 'firstJourney', 'distance', 'homeWorkJourney'];
const wayToEarnPointsMap = {
  sponsorship: {
    icon: _lifeIllus.default,
    titleKey: 'commons.challenges.bttf_faq.points.sponsorship.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.sponsorship.description',
    valueKey: 'commons.stats.points',
    count: 100
  },
  firstJourney: {
    icon: _hourraIllus.default,
    titleKey: 'commons.challenges.bttf_faq.points.first_journey.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.first_journey.description',
    valueKey: 'commons.stats.points',
    count: 200
  },
  distance: {
    icon: _journeysIllus.default,
    titleKey: 'commons.challenges.bttf_faq.points.distance.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.distance.description',
    valueKey: 'commons.stats.points_per_km',
    count: 1
  },
  homeWorkJourney: {
    icon: _cyclistIllus.default,
    titleKey: 'commons.challenges.bttf_faq.points.home_work_journey.title',
    descriptionKey: 'commons.challenges.bttf_faq.points.home_work_journey.description',
    value: 'x 3'
  }
};
function FAQ() {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.25rem",
    fontWeight: 600
  }, t('commons.challenges.bttf_faq.title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.description')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    sx: {
      containerType: 'inline-size'
    }
  }, wayToEarnPoints.map(key => /*#__PURE__*/_react.default.createElement(PointsCard, {
    key: key,
    wayToEarnPointsKey: key
  })))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#cdf5e3",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    padding: 3,
    width: {
      '@': '100%',
      '@600': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _communicationIllus.default,
    width: 64
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenges.bttf_faq.communication_kit_card.title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.communication_kit_card.description'))), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    href: _environment.defaultEnvironment.bttf.communicationKitUrl,
    rel: "noreferrer",
    size: "small",
    target: "_blank",
    variant: "text"
  }, t('commons.challenges.bttf_faq.communication_kit_card.action')))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#d9e7ff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    padding: 3,
    width: {
      '@': '100%',
      '@600': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _ideaIllus.default,
    width: 64
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenges.bttf_faq.know_more_card.title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.know_more_card.description'))), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    endIcon: /*#__PURE__*/_react.default.createElement(_icons.RedirectIcon, null),
    href: "https://geovelo-entreprise.com/biketothefuture/",
    rel: "noreferrer",
    size: "small",
    target: "_blank",
    variant: "text"
  }, t('commons.challenges.bttf_faq.know_more_card.action'))))));
}
function PointsCard({
  wayToEarnPointsKey
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    titleKey,
    descriptionKey,
    icon,
    ...props
  } = wayToEarnPointsMap[wayToEarnPointsKey];
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#f3f6ff",
    borderRadius: 4,
    display: "flex",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: {
      '@': 'flex-start',
      '@500': 'center'
    },
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 8,
    display: "flex",
    flexShrink: 0,
    height: 64,
    justifyContent: "center",
    width: 64
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    width: 48
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700
  }, t(titleKey)), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t(descriptionKey)))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "#6210FF",
    fontWeight: 700
  }, 'value' in props ? props.value : t(props.valueKey, {
    count: props.count
  }))));
}
var _default = exports.default = FAQ;